// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grid\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\"><path d=\"M 10 0 L 0 0 0 10\" fill=\"none\" stroke=\"rgba%28255,255,255,0.05%29\" stroke-width=\"0.5\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grid%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><circle cx=\"20\" cy=\"20\" r=\"2\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"80\" cy=\"30\" r=\"1.5\" fill=\"rgba%28255,255,255,0.08%29\"/><circle cx=\"30\" cy=\"70\" r=\"1\" fill=\"rgba%28255,255,255,0.06%29\"/><circle cx=\"70\" cy=\"80\" r=\"1.2\" fill=\"rgba%28255,255,255,0.04%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 25%, #3b82f6 50%, #60a5fa 75%, #93c5fd 100%);
  min-height: 100vh;
  color: #1f2937;
  line-height: 1.6;
  position: relative;
}

body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

/* Main container */
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

/* Header */
.header {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  backdrop-filter: blur(20px);
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  padding: 1.5rem 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 10;
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%);
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 700;
  color: #1e3a8a;
  text-decoration: none;
  transition: all 0.2s ease;
}

.logo:hover {
  color: #3b82f6;
  transform: translateX(2px);
}

.logo:hover .logo-icon {
  color: #1e3a8a;
}

.logo-icon {
  font-size: 2rem;
  color: #3b82f6;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-text {
  font-size: 1.75rem;
  letter-spacing: -0.025em;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Header Logout Button Styles */
.header-logout-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: background-color 0.2s;
  margin-left: 0.5rem;
}

.header-logout-btn:hover {
  background: #c82333;
}

.user-name {
  font-weight: 600;
  color: #495057;
}

/* Update existing user-info styles if needed */
.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #6c757d;
}

.user-info span:first-child {
  color: #1e3a8a;
  font-weight: 600;
  position: relative;
}

.user-info span:first-child::before {
  content: '●';
  color: #10b981;
  margin-right: 0.5rem;
  font-size: 0.75rem;
}

.back-to-overview-btn {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 1rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.back-to-overview-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
  color: white;
}

/* Main content */
.main-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 2rem;
  position: relative;
}

.main-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

.transfer-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  padding: 2.5rem;
  width: 100%;
  max-width: 520px;
  position: relative;
  z-index: 1;
}

.transfer-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.transfer-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 0.5rem;
  letter-spacing: -0.025em;
}

.transfer-subtitle {
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
}

/* Form styles */
.transfer-form {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.95rem;
  letter-spacing: 0.01em;
}

.form-input {
  padding: 1rem 1.25rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
  color: #374151;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  background: #ffffff;
  box-shadow: 
    0 0 0 4px rgba(59, 130, 246, 0.1),
    0 1px 3px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.form-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.form-textarea {
  resize: vertical;
  min-height: 90px;
  font-family: inherit;
}

/* Button styles */
.transfer-button {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 1.25rem 2rem;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 1rem;
  letter-spacing: 0.01em;
  position: relative;
  overflow: hidden;
}

.transfer-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.transfer-button:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 20px 40px -12px rgba(30, 58, 138, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.1);
}

.transfer-button:hover::before {
  left: 100%;
}

.transfer-button:active {
  transform: translateY(-1px);
}

.transfer-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.transfer-button:disabled::before {
  display: none;
}

/* Account balance */
.account-balance {
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 16px;
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
}

.account-balance::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  pointer-events: none;
}

.balance-label {
  font-size: 0.95rem;
  opacity: 0.95;
  font-weight: 500;
}

.balance-amount {
  font-size: 1.75rem;
  font-weight: 700;
  margin-top: 0.5rem;
  letter-spacing: -0.025em;
}

/* Alert styles */
.alert {
  padding: 1.25rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  border: 1px solid;
}

.alert-success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #064e3b;
  border-color: #10b981;
}

.alert-error {
  background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);
  color: #7f1d1d;
  border-color: #ef4444;
}

.alert-warning {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  color: #78350f;
  border-color: #f59e0b;
}

/* Support widget styles */
.support-widget-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.support-widget {
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.1);
}

.widget-header {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  padding: 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.widget-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.widget-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.widget-iframe {
  width: 100%;
  height: 400px;
  border: none;
}

/* Loading spinner */
.loading-spinner {
  border: 3px solid rgba(59, 130, 246, 0.2);
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Page Styles */
.page {
  width: 100%;
  height: 100%;
}

.transfer-page {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Not Found Page */
.not-found-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.not-found-container {
  text-align: center;
  padding: 3rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  max-width: 500px;
  width: 100%;
}

.not-found-title {
  font-size: 6rem;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 1rem;
  line-height: 1;
  text-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.not-found-subtitle {
  font-size: 2rem;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 1rem;
}

.not-found-description {
  font-size: 1.1rem;
  color: #64748b;
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.not-found-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(30, 58, 138, 0.4);
  color: white;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.95);
  color: #3b82f6;
  border: 2px solid #3b82f6;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
}

.btn-secondary:hover {
  background: #3b82f6;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.4);
}

/* Account Overview Styles */
.account-overview {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.account-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.account-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 2rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.account-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  border-radius: 20px 20px 0 0;
}

.account-card.primary::before {
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
}

.account-card.secondary::before {
  background: linear-gradient(90deg, #059669 0%, #10b981 100%);
}

.account-card.tertiary::before {
  background: linear-gradient(90deg, #7c3aed 0%, #a855f7 100%);
}

.account-card:hover {
  transform: translateY(-4px);
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1);
}

.card-header {
  margin-bottom: 1.5rem;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

.card-subtitle {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

.card-amount {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
}

.card-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #64748b;
}

.card-status {
  color: #10b981;
  font-weight: 600;
}

.card-growth {
  font-size: 0.9rem;
  color: #10b981;
  font-weight: 600;
}

/* Quick Actions */
.quick-actions {
  margin-top: 1rem;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 1.5rem;
  position: relative;
  padding-left: 1rem;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: linear-gradient(to bottom, #3b82f6, #1e3a8a);
  border-radius: 2px;
}

.action-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}

.action-btn {
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;
}

.action-btn:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.25);
}

.action-btn.primary {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-color: #3b82f6;
  color: white;
}

.action-btn.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 40px -12px rgba(30, 58, 138, 0.4);
}

.action-btn.primary .action-title,
.action-btn.primary .action-subtitle {
  color: white;
}

.action-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.action-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.action-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
}

.action-subtitle {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

/* Recent Transactions */
.recent-transactions {
  margin-top: 1rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.view-all-btn {
  background: none;
  border: 2px solid #3b82f6;
  color: #3b82f6;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  background: #3b82f6;
  color: white;
}

.transactions-list {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  overflow: hidden;
}

.transaction-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
  transition: background-color 0.2s ease;
}

.transaction-item:last-child {
  border-bottom: none;
}

.transaction-item:hover {
  background: rgba(59, 130, 246, 0.02);
}

.transaction-icon {
  font-size: 1.5rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 50%;
  flex-shrink: 0;
}

.transaction-details {
  flex: 1;
}

.transaction-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.transaction-description {
  font-weight: 600;
  color: #374151;
  font-size: 1rem;
}

.transaction-amount {
  font-weight: 700;
  font-size: 1.1rem;
}

.transaction-amount.credit {
  color: #10b981;
}

.transaction-amount.debit {
  color: #ef4444;
}

.transaction-meta {
  display: flex;
  gap: 1rem;
  font-size: 0.85rem;
  color: #64748b;
  flex-wrap: wrap;
}

.transaction-date {
  font-weight: 500;
}

.transaction-reference {
  color: #3b82f6;
}

.transaction-balance {
  font-weight: 600;
  margin-left: auto;
}

/* Account Info Footer */
.account-info-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: rgba(248, 250, 252, 0.8);
  border-radius: 12px;
  font-size: 0.9rem;
}

.info-item {
  display: flex;
  gap: 0.5rem;
}

.info-label {
  color: #64748b;
  font-weight: 500;
}

.info-value {
  color: #374151;
  font-weight: 600;
}

/* Responsive design */
@media (max-width: 768px) {
  .header {
    padding: 1.25rem 1.5rem;
  }
  
  .logo-text {
    font-size: 1.5rem;
  }
  
  .logo-icon {
    font-size: 1.75rem;
  }
  
  .main-content {
    padding: 2rem 1rem;
  }
  
  .transfer-container {
    padding: 2rem;
    border-radius: 20px;
  }
  
  .support-widget {
    width: 95%;
    max-height: 90vh;
  }
}

@media (max-width: 480px) {
  .transfer-title {
    font-size: 1.75rem;
  }
  
  .form-input {
    font-size: 16px; /* Prevents zoom on iOS */
    padding: 0.875rem 1rem;
  }
  
  .transfer-button {
    padding: 1rem 1.5rem;
  }

  /* Account Overview Mobile */
  .account-overview {
    padding: 1rem;
    gap: 2rem;
  }

  .account-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .account-card {
    padding: 1.5rem;
  }

  .card-amount {
    font-size: 1.75rem;
  }

  .action-buttons {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .action-btn {
    padding: 1.25rem;
  }

  .transaction-item {
    padding: 1rem;
    flex-direction: column;
    gap: 0.75rem;
  }

  .transaction-main {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .transaction-meta {
    gap: 0.75rem;
  }

  .transaction-balance {
    margin-left: 0;
  }

  .account-info-footer {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  /* Not Found Mobile */
  .not-found-container {
    padding: 2rem;
    margin: 1rem;
  }

  .not-found-title {
    font-size: 4rem;
  }

  .not-found-subtitle {
    font-size: 1.5rem;
  }

  .not-found-actions {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 280px;
    justify-content: center;
  }
} 

/* Login Component Styles */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 2rem;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 1.2rem;
  color: #666;
} 

/* Auth Status Component Styles */
.auth-status {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
  font-size: 0.9rem;
}

.auth-user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.auth-user-name {
  font-weight: 600;
  color: #495057;
}

.auth-logout-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: background-color 0.2s;
}

.auth-logout-btn:hover {
  background: #c82333;
}

.auth-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #6c757d;
}

.auth-email {
  font-style: italic;
}

.auth-persistent {
  color: #28a745;
  font-weight: 500;
}

.auth-status-text {
  color: #6c757d;
  font-style: italic;
}

.auth-status-note {
  color: #17a2b8;
  font-size: 0.8rem;
  margin-left: 0.5rem;
} `, "",{"version":3,"sources":["webpack://./client/src/styles/main.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yGAAyG;EACzG,oGAAoG;EACpG,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;oFAEkF;EAClF,oBAAoB;EACpB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,0CAA0C;EAC1C,iDAAiD;EACjD,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAyV;EACzV,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB;;sCAEoC;EACpC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB;;kCAEgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAiW;EACjW,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB;;sCAEoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB;;sCAEoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe,EAAE,yBAAyB;IAC1C,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 25%, #3b82f6 50%, #60a5fa 75%, #93c5fd 100%);\n  min-height: 100vh;\n  color: #1f2937;\n  line-height: 1.6;\n  position: relative;\n}\n\nbody::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Main container */\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n\n/* Header */\n.header {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  backdrop-filter: blur(20px);\n  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.08);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n  padding: 1.5rem 2.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  z-index: 10;\n}\n\n.header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%);\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 700;\n  color: #1e3a8a;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.logo:hover {\n  color: #3b82f6;\n  transform: translateX(2px);\n}\n\n.logo:hover .logo-icon {\n  color: #1e3a8a;\n}\n\n.logo-icon {\n  font-size: 2rem;\n  color: #3b82f6;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.logo-text {\n  font-size: 1.75rem;\n  letter-spacing: -0.025em;\n  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Header Logout Button Styles */\n.header-logout-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.4rem 0.8rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  margin-left: 0.5rem;\n}\n\n.header-logout-btn:hover {\n  background: #c82333;\n}\n\n.user-name {\n  font-weight: 600;\n  color: #495057;\n}\n\n/* Update existing user-info styles if needed */\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n\n.user-info span:first-child {\n  color: #1e3a8a;\n  font-weight: 600;\n  position: relative;\n}\n\n.user-info span:first-child::before {\n  content: '●';\n  color: #10b981;\n  margin-right: 0.5rem;\n  font-size: 0.75rem;\n}\n\n.back-to-overview-btn {\n  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-left: 1rem;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n}\n\n.back-to-overview-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);\n  color: white;\n}\n\n/* Main content */\n.main-content {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3rem 2rem;\n  position: relative;\n}\n\n.main-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grid\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\"><path d=\"M 10 0 L 0 0 0 10\" fill=\"none\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"0.5\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grid)\"/></svg>');\n  pointer-events: none;\n}\n\n.transfer-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 24px;\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n  padding: 2.5rem;\n  width: 100%;\n  max-width: 520px;\n  position: relative;\n  z-index: 1;\n}\n\n.transfer-header {\n  text-align: center;\n  margin-bottom: 2.5rem;\n}\n\n.transfer-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1e3a8a;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.025em;\n}\n\n.transfer-subtitle {\n  color: #64748b;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Form styles */\n.transfer-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.95rem;\n  letter-spacing: 0.01em;\n}\n\n.form-input {\n  padding: 1rem 1.25rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  background: #ffffff;\n  color: #374151;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  background: #ffffff;\n  box-shadow: \n    0 0 0 4px rgba(59, 130, 246, 0.1),\n    0 1px 3px 0 rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.form-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 90px;\n  font-family: inherit;\n}\n\n/* Button styles */\n.transfer-button {\n  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);\n  color: white;\n  border: none;\n  padding: 1.25rem 2rem;\n  border-radius: 12px;\n  font-size: 1.05rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-top: 1rem;\n  letter-spacing: 0.01em;\n  position: relative;\n  overflow: hidden;\n}\n\n.transfer-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.transfer-button:hover {\n  transform: translateY(-3px);\n  box-shadow: \n    0 20px 40px -12px rgba(30, 58, 138, 0.4),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n.transfer-button:hover::before {\n  left: 100%;\n}\n\n.transfer-button:active {\n  transform: translateY(-1px);\n}\n\n.transfer-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.transfer-button:disabled::before {\n  display: none;\n}\n\n/* Account balance */\n.account-balance {\n  background: linear-gradient(135deg, #059669 0%, #10b981 100%);\n  color: white;\n  padding: 1.5rem;\n  border-radius: 16px;\n  text-align: center;\n  margin-bottom: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.account-balance::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><circle cx=\"20\" cy=\"20\" r=\"2\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"80\" cy=\"30\" r=\"1.5\" fill=\"rgba(255,255,255,0.08)\"/><circle cx=\"30\" cy=\"70\" r=\"1\" fill=\"rgba(255,255,255,0.06)\"/><circle cx=\"70\" cy=\"80\" r=\"1.2\" fill=\"rgba(255,255,255,0.04)\"/></svg>');\n  pointer-events: none;\n}\n\n.balance-label {\n  font-size: 0.95rem;\n  opacity: 0.95;\n  font-weight: 500;\n}\n\n.balance-amount {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin-top: 0.5rem;\n  letter-spacing: -0.025em;\n}\n\n/* Alert styles */\n.alert {\n  padding: 1.25rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  border: 1px solid;\n}\n\n.alert-success {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #064e3b;\n  border-color: #10b981;\n}\n\n.alert-error {\n  background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);\n  color: #7f1d1d;\n  border-color: #ef4444;\n}\n\n.alert-warning {\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  color: #78350f;\n  border-color: #f59e0b;\n}\n\n/* Support widget styles */\n.support-widget-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.support-widget {\n  background: white;\n  border-radius: 20px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.4),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n.widget-header {\n  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);\n  color: white;\n  padding: 1.25rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.widget-close {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  width: 2.5rem;\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.widget-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n}\n\n.widget-iframe {\n  width: 100%;\n  height: 400px;\n  border: none;\n}\n\n/* Loading spinner */\n.loading-spinner {\n  border: 3px solid rgba(59, 130, 246, 0.2);\n  border-top: 3px solid #3b82f6;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Page Styles */\n.page {\n  width: 100%;\n  height: 100%;\n}\n\n.transfer-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Not Found Page */\n.not-found-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n}\n\n.not-found-container {\n  text-align: center;\n  padding: 3rem;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 24px;\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n  max-width: 500px;\n  width: 100%;\n}\n\n.not-found-title {\n  font-size: 6rem;\n  font-weight: 700;\n  color: #3b82f6;\n  margin-bottom: 1rem;\n  line-height: 1;\n  text-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);\n}\n\n.not-found-subtitle {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #1e3a8a;\n  margin-bottom: 1rem;\n}\n\n.not-found-description {\n  font-size: 1.1rem;\n  color: #64748b;\n  margin-bottom: 2.5rem;\n  line-height: 1.6;\n}\n\n.not-found-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px -5px rgba(30, 58, 138, 0.4);\n  color: white;\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.95);\n  color: #3b82f6;\n  border: 2px solid #3b82f6;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n}\n\n.btn-secondary:hover {\n  background: #3b82f6;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.4);\n}\n\n/* Account Overview Styles */\n.account-overview {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\n.account-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.account-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  padding: 2rem;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.account-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  border-radius: 20px 20px 0 0;\n}\n\n.account-card.primary::before {\n  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);\n}\n\n.account-card.secondary::before {\n  background: linear-gradient(90deg, #059669 0%, #10b981 100%);\n}\n\n.account-card.tertiary::before {\n  background: linear-gradient(90deg, #7c3aed 0%, #a855f7 100%);\n}\n\n.account-card:hover {\n  transform: translateY(-4px);\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n.card-header {\n  margin-bottom: 1.5rem;\n}\n\n.card-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.25rem;\n}\n\n.card-subtitle {\n  font-size: 0.9rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.card-amount {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: #1e3a8a;\n  margin-bottom: 1rem;\n  letter-spacing: -0.025em;\n}\n\n.card-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.card-status {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.card-growth {\n  font-size: 0.9rem;\n  color: #10b981;\n  font-weight: 600;\n}\n\n/* Quick Actions */\n.quick-actions {\n  margin-top: 1rem;\n}\n\n.section-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e3a8a;\n  margin-bottom: 1.5rem;\n  position: relative;\n  padding-left: 1rem;\n}\n\n.section-title::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 24px;\n  background: linear-gradient(to bottom, #3b82f6, #1e3a8a);\n  border-radius: 2px;\n}\n\n.action-buttons {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n.action-btn {\n  background: rgba(255, 255, 255, 0.95);\n  border: 2px solid #e5e7eb;\n  border-radius: 16px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-align: left;\n}\n\n.action-btn:hover {\n  border-color: #3b82f6;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.25);\n}\n\n.action-btn.primary {\n  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);\n  border-color: #3b82f6;\n  color: white;\n}\n\n.action-btn.primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 20px 40px -12px rgba(30, 58, 138, 0.4);\n}\n\n.action-btn.primary .action-title,\n.action-btn.primary .action-subtitle {\n  color: white;\n}\n\n.action-icon {\n  font-size: 2rem;\n  flex-shrink: 0;\n}\n\n.action-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.action-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.action-subtitle {\n  font-size: 0.9rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Recent Transactions */\n.recent-transactions {\n  margin-top: 1rem;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.view-all-btn {\n  background: none;\n  border: 2px solid #3b82f6;\n  color: #3b82f6;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.view-all-btn:hover {\n  background: #3b82f6;\n  color: white;\n}\n\n.transactions-list {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.transaction-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.5rem;\n  border-bottom: 1px solid rgba(229, 231, 235, 0.5);\n  transition: background-color 0.2s ease;\n}\n\n.transaction-item:last-child {\n  border-bottom: none;\n}\n\n.transaction-item:hover {\n  background: rgba(59, 130, 246, 0.02);\n}\n\n.transaction-icon {\n  font-size: 1.5rem;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(59, 130, 246, 0.1);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.transaction-details {\n  flex: 1;\n}\n\n.transaction-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n\n.transaction-description {\n  font-weight: 600;\n  color: #374151;\n  font-size: 1rem;\n}\n\n.transaction-amount {\n  font-weight: 700;\n  font-size: 1.1rem;\n}\n\n.transaction-amount.credit {\n  color: #10b981;\n}\n\n.transaction-amount.debit {\n  color: #ef4444;\n}\n\n.transaction-meta {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.85rem;\n  color: #64748b;\n  flex-wrap: wrap;\n}\n\n.transaction-date {\n  font-weight: 500;\n}\n\n.transaction-reference {\n  color: #3b82f6;\n}\n\n.transaction-balance {\n  font-weight: 600;\n  margin-left: auto;\n}\n\n/* Account Info Footer */\n.account-info-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background: rgba(248, 250, 252, 0.8);\n  border-radius: 12px;\n  font-size: 0.9rem;\n}\n\n.info-item {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.info-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.info-value {\n  color: #374151;\n  font-weight: 600;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .header {\n    padding: 1.25rem 1.5rem;\n  }\n  \n  .logo-text {\n    font-size: 1.5rem;\n  }\n  \n  .logo-icon {\n    font-size: 1.75rem;\n  }\n  \n  .main-content {\n    padding: 2rem 1rem;\n  }\n  \n  .transfer-container {\n    padding: 2rem;\n    border-radius: 20px;\n  }\n  \n  .support-widget {\n    width: 95%;\n    max-height: 90vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .transfer-title {\n    font-size: 1.75rem;\n  }\n  \n  .form-input {\n    font-size: 16px; /* Prevents zoom on iOS */\n    padding: 0.875rem 1rem;\n  }\n  \n  .transfer-button {\n    padding: 1rem 1.5rem;\n  }\n\n  /* Account Overview Mobile */\n  .account-overview {\n    padding: 1rem;\n    gap: 2rem;\n  }\n\n  .account-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .account-card {\n    padding: 1.5rem;\n  }\n\n  .card-amount {\n    font-size: 1.75rem;\n  }\n\n  .action-buttons {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .action-btn {\n    padding: 1.25rem;\n  }\n\n  .transaction-item {\n    padding: 1rem;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .transaction-main {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n\n  .transaction-meta {\n    gap: 0.75rem;\n  }\n\n  .transaction-balance {\n    margin-left: 0;\n  }\n\n  .account-info-footer {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n\n  /* Not Found Mobile */\n  .not-found-container {\n    padding: 2rem;\n    margin: 1rem;\n  }\n\n  .not-found-title {\n    font-size: 4rem;\n  }\n\n  .not-found-subtitle {\n    font-size: 1.5rem;\n  }\n\n  .not-found-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n    max-width: 280px;\n    justify-content: center;\n  }\n} \n\n/* Login Component Styles */\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  padding: 2rem;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  font-size: 1.2rem;\n  color: #666;\n} \n\n/* Auth Status Component Styles */\n.auth-status {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 1rem;\n  margin: 1rem 0;\n  font-size: 0.9rem;\n}\n\n.auth-user-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.auth-user-name {\n  font-weight: 600;\n  color: #495057;\n}\n\n.auth-logout-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: background-color 0.2s;\n}\n\n.auth-logout-btn:hover {\n  background: #c82333;\n}\n\n.auth-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8rem;\n  color: #6c757d;\n}\n\n.auth-email {\n  font-style: italic;\n}\n\n.auth-persistent {\n  color: #28a745;\n  font-weight: 500;\n}\n\n.auth-status-text {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.auth-status-note {\n  color: #17a2b8;\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
